import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters.js";

// model for product_attributes
export class ProductAttributeOption extends DataObject {
    _type = "productAttributeOption";

    id;
    attribute_id;
    attribute_name;
    slug;
    name;
    type;
    order;
    position;
    bo_can_delete;
    show_action_menu;
}

export class ProductAttribute extends DataObject {
    _type = "productAttribute";

    id;
    name;
    slug;
    count;
    options = {};
}

export class ProductAttributeMapperParameter extends Parameter {
    productAttributeMapper;
    productAttributeOptionMapper;
}

export class ProductAttributeFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {Object, null} data Data to construct the ProductAttribute object with. Also creates a product object using MetaFactory if data is not null.
     * @returns {Notification}
     */
    static construct(productAttributeMapperParameter, data = null) {
        if (data != null) {
            let productAttribute = DataObjectFactory.getInstance().constructWithMapper(
                ProductAttribute,
                productAttributeMapperParameter.productAttributeMapper,
                data
            );

            // connecting ProductAttributeOption with ProductAttribute's options
            if (data.options != null) {
                let options = {};
                data.options.forEach((optionData) => {
                    const option = DataObjectFactory.getInstance().constructWithMapper(
                        ProductAttributeOption,
                        productAttributeMapperParameter.productAttributeOptionMapper,
                        optionData
                    );
                    option.attribute_name = productAttribute.name;
                    // assign option obj to temp variable
                    options[option.id] = option;
                });

                productAttribute.options = options;
            }

            return productAttribute;
        }

        return null;
    }
}
